<template>
  <div
    class="d-flex justify-end mt-5"
    :class="$root.isMobile ? 'flex-column' : ''"
  >
    <v-btn
      depressed
      tile
      outlined
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/technicians')"
    >
      Close
    </v-btn>
    <template v-if="isAdmin">
      <v-btn
        depressed
        tile
        outlined
        v-if="isUpdate"
        color="error"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="remove"
      >
        Delete
      </v-btn>
      <v-btn
        depressed
        tile
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit(isUpdate ? 'update' : 'save')"
      >
        Submit
      </v-btn>
    </template>
  </div>
</template>

<script>
import { technicianGroups, technicians } from "../../../assets/js/firebase";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      confirm: false,
      message: "Are you sure you want to delete this technician?"
    };
  },
  computed: {
    isUpdate() {
      return this.$route.name === "technicians-update";
    }
  },
  methods: {
    async remove() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this technician?",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            let { id } = vm.$route.params;
            let snap = await technicianGroups
              .where("users", "array-contains", id)
              .get();
            if (!snap.empty) {
              vm.$root.alert(
                "This technician cannot be deleted since its part of the SMS Group."
              );
              vm.$root.loader = false;
              return;
            }
            await technicians.doc(id).delete();
            vm.$router.replace("/technicians");
            vm.$root.loader = false;
          } catch (error) {
            vm.$root.loader = false;
            vm.$root.alert(error.message);
          }
        }
      });
    }
  }
};
</script>
<style></style>
